export default __webpack_public_path__ + "static/media/45_desktop.68ae796a.jpg";